import { render, staticRenderFns } from "./ToastificationVariant.vue?vue&type=template&id=1845c836"
import script from "./ToastificationVariant.vue?vue&type=script&lang=js"
export * from "./ToastificationVariant.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports